import BrandsList from "../../../components/BrandsList";
import { BrandsPageText } from "../../../components/BrandsPageText";
import SearchBar from "../../../components/SearchBar";
import { Button } from "../../../design-system/Button";
import { Spacer } from "../../../design-system/Spacer";
import Title from "../../../design-system/Title";
import { BrandsType } from "../../../types/brands";
import { vehicleKindsView } from "../../../types/vehicleKinds";

export default function CarBrandsView({
  brands,
  onClick,
  onChange,
}: {
  brands: BrandsType;
  onClick: () => void;
  onChange: (text: string) => void;
}) {
  return (
    <>
      <Title title="Montadoras" />
      <Spacer size="1rem" />
      <BrandsPageText vehicleKindView={vehicleKindsView["car"]} />
      <Spacer size="1rem" />
      <SearchBar placeholder="Pesquisar montadora" onChange={onChange} />
      <Spacer size="1rem" />
      <BrandsList brands={brands} vehicleKindView={vehicleKindsView["car"]} />
      <Button label="Voltar" style={`primary`} onClick={onClick} />
    </>
  );
}
